'use client';

import { c as _c } from "react/compiler-runtime";
import { useHelpWidget } from '../HelpWidgetContext';
const HelpSwatchSamples = () => {
  const $ = _c(12);
  const {
    setPanel,
    closeWidget
  } = useHelpWidget();
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <h3 className="text-md font-semibold mb-3">Swatch Samples</h3>;
    t1 = <p className="text-sm mb-3">We are happy to provide physical samples of fabrics and finishes to assist with your selection process. There is no charge for this service.</p>;
    t2 = <p className="text-sm mb-4">To order samples please visit the product page of the item you are interested in and click on the fabric / finish button on the right side of the product page.</p>;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="mb-4"><div className="text-xs text-light uppercase tracking-wide mb-2">step 1</div><p className="text-sm">Click the heart icon next to each swatch you would like to sample.</p></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="mb-4"><div className="text-xs text-light uppercase tracking-wide mb-2">step 2</div><p className="text-sm">Click the "order samples" button and complete the shipping form and final selections. Samples are shipped in 2 to 5 business days.</p></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== closeWidget) {
    t5 = <div className="mb-4"><button onClick={closeWidget} className="btn btn-default btn-sm">order samples</button></div>;
    $[5] = closeWidget;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== setPanel) {
    t6 = <button onClick={() => setPanel("main")} className="text-sm text-primary hover:underline">return to help menu</button>;
    $[7] = setPanel;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <div className="p-4">{t0}{t1}{t2}{t3}{t4}{t5}{t6}</div>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
export default HelpSwatchSamples;